import React, { FC, ReactElement, ReactNode } from 'react';
import { faAngleUp } from '@fortawesome/free-solid-svg-icons/faAngleUp';
import { faAngleDown } from '@fortawesome/free-solid-svg-icons/faAngleDown';

import styles from './infoTableStyles.scss';

import Accordion, {
  AccordionContent,
  AccordionTitle
} from 'buyside/components/presentation/Accordion/accordionComponents';

export type StyleProps = {
  dataStyle: string;
  labelStyle: string;
};

const InfoTable: FC<{
  children: (props: StyleProps & { blur: string }) => ReactNode;
  dataTag?: string;
  title: string;
  isLocked?: boolean;
}> = ({ dataTag, children, title, isLocked }): ReactElement => (
  <div>
    <Accordion initialOpen={window.innerWidth > 768 && !isLocked}>
      <AccordionTitle
        expandable
        expandIcon={faAngleDown}
        dataTag={dataTag || 'infoTable'}
        collapseIcon={faAngleUp}
        isLocked={isLocked}
      >
        {title}
      </AccordionTitle>
      <AccordionContent>
        {children &&
          children({ labelStyle: styles.rowLabel, dataStyle: styles.rowInfo, blur: styles.blur })}
      </AccordionContent>
    </Accordion>
  </div>
);

export default InfoTable;
